var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form-layout',{attrs:{"title":`${_vm.action} ${_vm.$tc(`user.${_vm.category}`, 1)}`},on:{"submit":_vm.onSubmit}},[_c('v-form',{ref:"form"},[_c('user-group-edit-form',{attrs:{"user-group":_vm.userGroup,"category":_vm.category}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }